import React from "react";
import { Link } from "react-router-dom";

const clearLocalStorage = () => {
    localStorage.clear();
};

const Home = () => {
    return (
        <div className="App">
            <govco-header
                ishome="true"
                isbeta="false"
                usuario=""
                fixed="false"
                auth_active="false"
                search_active="false"
            ></govco-header>
            <govco-accesibility-bar></govco-accesibility-bar>
            <govco-back-to-top></govco-back-to-top>
            <div className="container">
                <div className="row">
                    <div className="col-12"></div>
                    <div className="col-lg-8 mt-5">
                        <h2>
                            BEPS (Solicitud para beneficios económicos
                            periódicos){" "}
                        </h2>

                        <div className="form-row ">
                            <Link to={"/consultar-tramite"}>
                                <div
                                    className="card gov-co-tramite-card"
                                    onClick={clearLocalStorage()}
                                >
                                    <div className="card-header text-center">
                                        Consultar trámite
                                    </div>
                                    <div className="card-body">
                                        <p className="card-text">
                                            Opción para consultar el estado de
                                            un trámite Beps.
                                        </p>
                                    </div>
                                </div>
                            </Link>
                            <Link to={"/realizar-tramite"}>
                                <div
                                    className="card gov-co-tramite-card ml-3"
                                    onClick={clearLocalStorage()}
                                >
                                    <div className="card-header text-center">
                                        Realizar trámite
                                    </div>
                                    <div className="card-body">
                                        <p className="card-text">
                                            Opción para radicación de un trámite
                                            nuevo para Beps
                                        </p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-1 mt-5"></div>
                    <div className="col-lg-3 mt-5">
                        <div className="gov-co-servi">
                            <component-doubts-contact
                                email="ayuda@scrd.gov.co"
                                phone="(601) 327 48 50"
                                faq="test"
                                adicionales='[
              {
                  "title": "Atención Presencial",
                  "value": "Carrera 8 No 9-83 de lunes a viernes en Jornada continua de 7:30 a.m. a 4;30 p.m"
              }
          ]'
                                className="d-flex justify-content-end"
                            ></component-doubts-contact>
                            <component-qualify-procedure
                                className="d-flex justify-content-end"
                                fullscreen="false"
                            ></component-qualify-procedure>
                        </div>
                    </div>
                </div>
            </div>
            <govco-footer
                color_fondo="#5d4293"
                titulo_entidad="Secretaría de Cultura, Recreación y Deporte"
                url_logo="https://www.culturarecreacionydeporte.gov.co/sites/default/files/2022-08/Logo-secretaria-cultura-recreacion-deporte-morado.svg"
                url_redirect_logo="https://www.culturarecreacionydeporte.gov.co/"
                alt_url_logo="Logo de la Secretaría de Cultura, Recreación y Deporte"
                description_Logo="Logo de la Secretaría de Cultura, Recreación y Deporte"
                direccion="Cra 8 # 9 - 83, Bogotá - Colombia"
                codigo_postal="111711"
                conmutador="(601) 327 48 50"
                horario_atencion="Lunes a viernes 7:30 a.m. a 4:30 p.m."
                correo_entidad="correspondencia.externa@scrd.gov.co"
                cuenta_twiter="CulturaenBta"
                cuenta_instagram="culturaenbta"
                cuenta_facebook="CulturaenBogota"
                politicas="https://www.culturarecreacionydeporte.gov.co/es/politica-de-privacidad"
                mapa_sitio="https://www.culturarecreacionydeporte.gov.co/sitemap"
                terminos_condiciones="#"
            ></govco-footer>
        </div>
    );
};

export default Home;
